import {ACCEPTED_ATTACHMENT_TYPES} from "./doctorMessages.constants";

/** @param {import("./doctorMessages.types").ConversationContact[]} conversations */
export const sortConversations = conversations =>
  [...conversations].sort((first, second) => {
    const firstDate = first.last_message_date
      ? new Date(first.last_message_date).getTime()
      : 0;
    const secondDate = second.last_message_date
      ? new Date(second.last_message_date).getTime()
      : 0;
    if (secondDate !== firstDate) return secondDate - firstDate;
    return (second.unread_messages || 0) - (first.unread_messages || 0);
  });

export const getUnreadTotal = conversations =>
  conversations.reduce((total, conversation) => total + (conversation.unread_messages || 0), 0);

export const getUnreadCounts = (doctors, patients) => ({
  doctorCount: getUnreadTotal(doctors),
  patientCount: getUnreadTotal(patients),
});

/** @param {import("./doctorMessages.types").ConversationContact[]} conversations */
export const markConversationRead = (conversations, conversationId) =>
  conversations.map(conversation =>
    String(conversation.id) === String(conversationId)
      ? {...conversation, unread_messages: 0}
      : conversation,
  );

/** @param {import("./doctorMessages.types").ConversationMessage[]} messages */
export const collectLinkedPatients = messages => {
  const seenIds = new Set();
  return messages.reduce((patients, message) => {
    if (!message?.linked_to || seenIds.has(String(message.linked_to))) return patients;
    seenIds.add(String(message.linked_to));
    patients.push({
      id: message.linked_to,
      name: message.link_patient_name || `Patient #${message.linked_to}`,
      linked_to: message.linked_to,
      link_patient_name: message.link_patient_name || null,
    });
    return patients;
  }, []);
};

export const validateAttachment = file => {
  if (!file) return {valid: false, reason: "No file selected."};
  if (!ACCEPTED_ATTACHMENT_TYPES.includes(file.type)) {
    return {
      valid: false,
      reason: "Invalid file type. Please select a JPG, PNG, PDF, or DOCX file.",
    };
  }
  return {valid: true};
};

export const appendConversationIfMissing = (conversations, contact) =>
  conversations.some(item => String(item.id) === String(contact.id))
    ? conversations
    : [...conversations, contact];
